<template>
	<div class="document page-break">
		<p style="text-align: right;">
			Приложение № {{ index }}
			<br>к Договору № {{ $root.contract.number }} от {{ $root.contract.date }}
		</p>
		<h4 class="h">Спецификация № {{ index }}</h4>
		<div class="spcf_table">
			<table class="table table-bordered" cellpadding="6">
				<tbody>
					<tr>
						<th>№ п.п.</th>
						<th>Наименование</th>
						<th>Единица измерения</th>
						<th>Количество лицензий</th>
						<th>Цена, руб.</th>
						<td><b>Сумма(без НДС)</b><br></td>
					</tr>
					<tr>
						<td>1</td>
						<td>Информационно-аналитическая система «Seldon 1.7». Право использования (простая (неисключительная) лицензия сроком на {{ license_period }} месяцев.</td>
						<td>шт.</td>
						<td>{{ license_count }}</td>
						<td>{{ license_price }}</td>
						<td>{{ license_total_sum }}</td>
					</tr>
					<tr>
						<td></td>
						<th colspan="4">Итого:</th>
						<th>{{ license_total_sum  }}</th>
					</tr>
				</tbody>
			</table>
		</div>
		<div>
			<p style="margin-top: 0px;">
				<b>Основные функциональные возможности Программы (в конфигурации лицензии Premium):</b>
				<br><i>Программа для ЭВМ «Информационно-аналитическая система «Seldon 1.7»</i> – программный комплекс, позволяющий осуществлять мониторинг закупок государственного и коммерческого сектора, проводимых на территории Российской Федерации и странах ближнего зарубежья, а так же имеющий следующие функциональные возможности:
				<br>1.	Доступ к информации о закупках, размещаемых на электронных торговых площадках России и стран ближнего зарубежья (без доступа к площадкам).
				<br>2.	Функция мониторинга и анализа информации о закупках по заданным критериям.
				<br>3.	Функция мониторинга и анализа ценовых предложений.
				<br>4.	Доступ к информации о потенциальных заказчиках и поставщиках из различных источников открытых данных, в т.ч. возможность проверки их нахождения в реестре недобросовестных поставщиков, участие в арбитражных делах.
				<br>5.	Функция анализа состояния рынка и его секторов в требуемых срезах (региональные, отраслевые, продуктовые).
				<br><b>Подбробнее о фукциональных возможностях Программы (в конфигурации лицензии Premium):</b>
				<br>1.	Поиск и предоставление информации о:
				<br>•	государственных закупках, размещенных на официальном сайте единой информационной системы (далее ЕИС) и заключаемых в рамках Федерального закона от 05.04.2013 № 44-ФЗ «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» , Федерального закона от 18.07.2011 N 223-ФЗ "О закупках товаров, работ, услуг отдельными видами юридических лиц", Постановления Правительства Российской Федерации от 01.07.2016 № 615 "О порядке привлечения подрядных организаций для оказания услуг и (или) выполнения работ по капитальному ремонту общего имущества в многоквартирных домах и порядке осуществления закупок товаров, работ, услуг в целях выполнения функций специализированной некоммерческой организации, которая осуществляет деятельность, направленную на обеспечение проведения капитального ремонта общего имущества в многоквартирных домах", а также поиск и предоставление информации о государственных закупках с федеральных электронных торговых площадок, иных электронных площадок , в том числе по малым закупкам.
				<br>•	коммерческих закупках, размещенных на коммерческих электронных площадках и электронных торговых площадках компаний.
				<br>•	международных закупках стран ближнего зарубежья. 
				<br>•	планируемых государственных закупках на ЕИС.
				<br>2.	Предоставление реестров аналитических отчетов по данным извещений о закупках, контрактов и протоколов.
				<br>3.	Возможность просмотра и выгрузки данных о закупках, отмеченных Лицензиатом как «избранные».
				<br>4.	Предоставление данных о компаниях, в том числе информация из реестра недобросовестных поставщиков, имеющихся жалобах в Федеральной антимонопольной службе.
				<br>5.	Возможность выгрузки информации о закупках предоставляемую в формате Excel, содержащую данные «первых двадцати» страниц выдачи Программы (до 100 закупок на кажой странице), при этом возможно осуществлять до 50-ти выгрузок в сутки.
				<br>6.	Возможность выгрузки аналитических отчетов предоставляемых в формате Excel, содержащих данные до 5000 строк, при этом возможно осуществлять до 50-ти выгрузок в сутки.
				<br>7.	Возможность сохранять поисковые запросы (далее - фильтры) для поиска закупок. Количество возможных единовременно сохраненных фильтров по закупкам: до 50.
				<br>8.	Возможность формирования Программой и направления письменных уведомлений на электронную почту Лицензиата о новых объявленных закупках (до 130 позиций) по сохраненным Лицензиатом фильтрам. Максимальное количество подключенных к рассылке фильтров - до 25.
				<br>9.	Возможность формирования Программой и направление письменных уведомлений на электронную почту Сублицензиата о планируемых закупках (до 80 позиций) по сохраненным Лицензиатом фильтрам. Максимальное количество подключенных к рассылке сохраненных фильтров по планируемым закупкам: до 10.
				<br>10.	Возможность формирования Программой и направления быстрых письменных уведомлений на электронную почту Сублицензиата о новых объявленных  малых закупках (до 100 закупок в сутки) по сохраненным Сублицензиатом фильтрам. Максимальное количество подключенных к рассылке фильтров: до 25.
				<br>11.	Техническая поддержка Сублицензиата по надлежащему использованию Программы на весь период использования путем обращения по телефону, по электронной почте, с помощью сервиса «чат-бот» с использованием мессенджер Telegram, или путем использования кнопки «Связаться с консультантом» в Программе, в том числе путем обращения к персональному менеджеру, предоставленного Лицензиатом.
				<br>12.	Поддержка Сублицензиата по настройке поисковых запросов (до 20) в течение всего периода использования лицензии на Программу.
				<br>13.	Инструктаж специалистом колл-центра Лицензиата по использованию Программы для четырех представителей Сублицензиата в течение всего периода использования лицензии на Программу.
				<small>
					<br><br><span style="text-decoration: underline;">Минимальные технические требования:</span>
					<br>Тип ЭВМ:  IBM – совместимый компьютер, 2Гб ОЗУ, 300 Мб HDD, монитор с разрешением не менее 1280х1024, клавиатура, мышь.
					<br>Операционная  система Windows 7  SP 1  и выше,  Windows Server 2008  SP2 и  выше 
					<br>•		Установленная версия Microsoft .NET Framework 4.6 и выше
					<br>•		не менее 512 Мб свободного дискового пространства; 
					<br>•		2 Гб оперативной памяти; 
					<br>•		Internet - соединение 1024 Кб/с и выше; 
					<br>•		минимальное разрешение экрана 1280x1024.
				</small>
			</p>
		</div>
		<div>
			<table class="table table-bordered">
				<tbody>
					<tr>
						<th>
							<p>
								Лицензиат
								<br>{{ $root.licentiate.short_name }}
							</p>
						</th>
						<th>
							<p>
								Сублицензиат
								<br>{{ $root.sublicentiate.short_name }}
							</p>
						</th>
					</tr>
					<tr>
						<td>
							<p>{{ $root.licentiate.position }}</p>
							<br>_________________/{{ $root.licentiate.director_short }}/
								<br>М.П.
						</td>
						<td>
							<p>{{ $root.sublicentiate.position }}</p>
							<br>_________________/{{ $root.sublicentiate.director_short }}/
								<br>М.П.
						</td>
					</tr>
					<div class="sign_area">
						<div class="sign"></div>
					</div>
				</tbody>
			</table>
		</div>
	</div>
</template>
<script>
	export default {
		props: [
			'index',
			'license_period', 
			'license_count', 
			'license_price', 
			'license_user_count', 
			'license_total_sum'
		],
	}
</script>